import React, {Component} from 'react';
import { Button, Modal } from 'react-bootstrap'
import _ from 'lodash';
import styles from "./Styles.module.css";

/**
 * @author Chris Okebata
 */


const PortalInfo = (props) => {
  const {info, desc} = props;

  return(
    <div className={styles.detailContainer}>
      <div className={styles._info}>
        {info}
      </div>
      <div className={styles.data}>
        {desc}
      </div>
    </div>
  )
};

class ViewPortalModal extends Component {

  render () {

    const {onHide, show, headerText, buttonText, portalData} = this.props;

    return (
      <Modal show={show} onHide={onHide} className="tms-modal-dialog">
        <Modal.Header closeButton>
          <Modal.Title>{headerText}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PortalInfo
            info={'Organization'}
            desc={_.get(portalData, 'organization.name')}
          />
          <PortalInfo
            info={'Display Name'}
            desc={_.get(portalData, 'displayLabel')}
          />
          <PortalInfo
            info={'Login URL'}
            desc={_.get(portalData, 'loginUrl')}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="success" className={styles.modalButton} onClick={onHide}>
            {buttonText}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export { ViewPortalModal };
